import React from 'react';

const HighlightText = ({ text, term }) => {
  const parts = text.split(new RegExp(`(${term})`, 'gi'));
  const highlightedText = parts.map((part, index) => {
    if (part.toLowerCase() === term.toLowerCase()) {
      return (
        <span key={index} style={{ backgroundColor: '#FEF9C3' }}>
          {part}
        </span>
      );
    }
    return part;
  });
  return highlightedText;
};

export default HighlightText;
